// Deliberately reads process.env rather than the resolved `deployableEnv`:
// this module is bundled into client chunks, where the deployable environment
// is unknown and `deployableEnv` falls back to 'development'. Since callers
// use this to skip log redaction, an unknown environment must read as
// not-development so redaction stays on.
export default (): boolean => process.env.DEPLOYABLE_ENV === 'development';
